// extracted by mini-css-extract-plugin
module.exports = {"description":"SignFrom__description__SggQX","Size":"SignFrom__Size__2D8bT","FileUpload":"SignFrom__FileUpload__V_euJ"};